import React, { useEffect, useState } from "react";
import videosource from "../assets/videos/homepagevideo2.mp4";
import { data } from "autoprefixer";
import { useLocation, useNavigate } from "react-router-dom";
import carInfo from "../utils/carInfo.json";

export default function CarForm() {
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [generation, setGeneration] = useState("");
  const [engine, setEngine] = useState("");
  const [cardata, setCarData] = useState({});
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToForm) {
      const form = document.getElementById("car-form");
      if (form) form.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.state]);

  const uniqueBrand = Array.from(new Set(carInfo.map((car) => car.make)));
  const uniqueModel = brand
    ? Array.from(
        new Set(
          carInfo.filter((car) => car.make === brand).map((car) => car.model)
        )
      )
    : [];
  const uniqueGeneration =
    brand && model
      ? Array.from(
          new Set(
            carInfo
              .filter((car) => car.make === brand && car.model === model)
              .map((car) => car.generation)
          )
        )
      : [];
  const uniqueEngine =
    brand && model && generation
      ? Array.from(
          new Set(
            carInfo
              .filter(
                (car) =>
                  car.make === brand &&
                  car.model === model &&
                  car.generation === generation
              )
              .map((car) => car.engine)
          )
        )
      : [];

  //   setCarData(carInfo);

  //   useEffect(() => {

  //   }, [brand, model, generation, engine]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (brand && model && generation && engine) {
      const filteredData = carInfo.filter(
        (car) =>
          car.make === brand &&
          car.model === model &&
          car.generation === generation &&
          car.engine === engine
      );
      setCarData(filteredData[0]);
      //   console.log(filteredData[0]);
    } else {
      setCarData({});
    }
  }, [engine]);

  function changeBrand(e) {
    const val = e.target.value;
    if (val === "selecteer uw merk") {
      setBrand("");
      document.querySelector("#model").disabled = true;
      document.querySelector("#generation").disabled = true;
      document.querySelector("#engine").disabled = true;
    } else {
      setBrand(val);
      if (carInfo.make === brand) setCarData();
      setModel("");
      setGeneration("");
      setEngine("");
      // console.log(val);
      document.querySelector("#model").disabled = false;
    }
  }
  function changeModel(e) {
    const val = e.target.value;
    if (val === "selecteer uw model") {
      setModel("");
      document.querySelector("#generation").disabled = true;
      document.querySelector("#engine").disabled = true;
    } else {
      setModel(val);
      setGeneration("");
      setEngine("");
      // console.log(val);
      document.querySelector("#generation").disabled = false;
    }
  }
  function changeGeneration(e) {
    const val = e.target.value;
    if (val === "selecteer je generatie") {
      setGeneration("");
      document.querySelector("#engine").disabled = true;
    } else {
      setGeneration(val);
      setEngine("");
      // console.log(val);
      document.querySelector("#engine").disabled = false;
    }
  }
  function changeEngine(e) {
    const val = e.target.value;
    if (val === "selecteer uw motor") {
      setEngine("");
    } else {
      setEngine(val);
      // console.log(val);
    }
  }

  //   console.log(JSON.stringify(cardata));
  async function handleSubmit(e) {
    e.preventDefault();

    if (!brand || !model || !generation || !engine) {
      const message = "Please select all details";
      alert(message);
      // setError(message)
      return;
    }
    // console.log(cardata);

    navigate("/car-details", { state: cardata });
  }

  return (
    <div
      className="flex flex-col-reverse md:flex-row  bg-black py-12 "
      id="car-form"
    >
      {/* Form Section */}
      <div className="relative w-full md:flex-1 bg-black bg-opacity-80 p-0 sm:p-12 z-10 lg:mt-12">
        <form className="space-y-4 p-8 bg-black bg-opacity-75 border-4 border-red-600 rounded-lg shadow-xl glow-form ml-0 md:ml-10 lg:ml-28 xl:ml-[230px] xl:mr-[-150px] 2xl:ml-[250px] w-[100%] md:w-[120%] lg:w-[100%] xl:w-[80%] 2xl:max-w-[80%]">
          <h2 className="text-white text-xl font-bold text-center">
            ZOEK UW PRESTATIE
          </h2>
          <div className="space-y-4">
            <div>
              <label className="text-white text-sm font-bold">BRAND*</label>

              <select
                value={brand}
                onChange={changeBrand}
                id="brand"
                className="w-full py-2 text-sm rounded-md font-bold mt-2 px-2"
              >
                <option className="font-bold"> selecteer uw merk </option>
                {uniqueBrand.map((make) => (
                  <option key={make} value={make} className="font-bold">
                    {make}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-white text-sm font-bold">MODEL*</label>

              <select
                value={model}
                onChange={changeModel}
                id="model"
                className="w-full py-2 text-sm rounded-md font-bold mt-2 px-2"
              >
                <option className="font-bold"> selecteer uw merk </option>
                {uniqueModel.map((make) => (
                  <option key={make} value={make} className="font-bold">
                    {make}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-white text-sm font-bold">
                GENERATION*
              </label>

              <select
                value={generation}
                onChange={changeGeneration}
                id="generation"
                className="w-full py-2 text-sm rounded-md font-bold mt-2 px-2"
              >
                <option className="font-bold"> selecteer uw merk </option>
                {uniqueGeneration.map((make) => (
                  <option key={make} value={make} className="font-bold">
                    {make}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-white text-sm font-bold">ENGINE*</label>

              <select
                value={engine}
                onChange={changeEngine}
                id="engine"
                className="w-full py-2 text-sm rounded-md font-bold mt-2 px-2"
              >
                <option className="font-bold"> selecteer uw merk </option>
                {uniqueEngine.map((make) => (
                  <option key={make} value={make} className="font-bold">
                    {make}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <button
            onClick={handleSubmit}
            value={data}
            className="w-full p-3 mt-4 bg-red-600 text-white rounded-md"
          >
            Optimalisatie
          </button>
        </form>
      </div>
      {/* Video Section (Now visible on mobile) */}
      <div className="relative w-full h-64 md:h-auto md:flex-1 bg-black mb-6 md:mb-0 sm:mr-14 lg:mr-20 xl:mr-[300px]">
        <video
          className="w-full h-full object-cover rounded-md"
          src={videosource}
          autoPlay
          loop
          muted
          playsInline
        />
      </div>

      {/* Glow Effect */}
      <style jsx>{`
        .glow-form {
          box-shadow: 0 0 20px rgba(255, 0, 0, 0.8);
        }
      `}</style>
    </div>
  );
}
